import api from "../api";
import { User } from '../../../db/_User'
export const signIn = (host: string): Promise<void> => {
  return new Promise((resolve) => {
    const origin = `${document.location.origin}${document.location.pathname}`
    getUserSignIn(host, origin, resolve)
  })
}

export const getUserSignIn = async (host: string, origin: string, resolve: () => void) => {
  try {
    const user = await api.get('/me') as User

    if (!user) {
      return window.location.href = `${host}/auth?origin=${encodeURIComponent(origin)}`
    }
    if (!user.admin) {
      alert('You are not authorized to access this page.  Please try again with an admin account')
      const { link } = await api.get('/signout') as { link: string }
      return window.location.href = link
    }
    return resolve()

  } catch (error) {
    alert('Login failed')
  }
}
